import React from "react";

export default function FeatureItem({ icon, title, description, fill = "#a6474b" }) {
  return (
    <div
      data-uk-grid="true"
      className="uk-grid-small uk-box-shadow-small"
      style={{ border: `1px solid ${fill}`, minHeight: 64, background: "#f6f6f6", overflow: "hidden" }}
    >
      <div className="uk-flex uk-flex-middle uk-flex-center uk-width-1-6 uk-background-default">
        <div style={{ color: fill, paddingRight: 15 }} data-uk-icon={`icon: ${icon}; ratio: 2`}></div>
      </div>
      {/* If description prop is included, render description. Else, reverse order. */}
      <div
        className={`${!description && "uk-flex-first"}
         bold uk-width-expand uk-text-center uk-flex uk-flex-middle uk-flex-around`}
      >
        {title}
      </div>
      {description && <div className="  uk-width-1-2 uk-flex uk-flex-middle uk-padding-small">{description}</div>}
    </div>
  );
}
